
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/narendra-vaidya",
      function () {
        return require("private-next-pages/narendra-vaidya.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/narendra-vaidya"])
      });
    }
  